import React, { FC } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

// Interface

export interface ContainerProps {
  narrow?: boolean;
}

// Styles

const StyledContainer = styled.div<ContainerProps>`
  ${({ theme: { media, space }, narrow }) => css`
    margin: 0 auto;
    padding: 0 ${space.medium};
    max-width: ${space.maxXLarge};

    // Narrow width

    ${narrow &&
    css`
      max-width: ${space.maxMediumCh};
    `}

    @media (min-width: ${media.medium}) {
      padding: 0 ${space.large};
    }

    @media (min-width: ${media.xLarge}) {
      padding: 0;
    }
  `};
`;

// JSX

export const Container: FC<React.PropsWithChildren<ContainerProps>> = ({
  children,
  narrow,
  ...rest
}) => (
  <StyledContainer narrow={narrow} {...rest}>
    {children}
  </StyledContainer>
);

export default Container;
